module.exports = __webpack_public_path__ + "bf7d26c238a1158994922b776b486868.svg";